export default __webpack_public_path__ + "static/media/img_tandberg_ex90-colorBkg.027ac873.png";